// removed by extract-text-webpack-plugin
module.exports = {"mainSectionSkeleton":"styles__mainSectionSkeleton___25DNE","whiteBackgroundSkeleton":"styles__whiteBackgroundSkeleton___2XSec","skeleton-loading":"styles__skeleton-loading___2diHF","table":"styles__table___1L4yR","tableHeader":"styles__tableHeader___37SAm","tableBody":"styles__tableBody___2Vqnq","skeleton":"styles__skeleton___3pvNc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Skeleton/ScheduleSkeleton/styles.css
// module id = 2534
// module chunks = 0